module.exports = __webpack_public_path__ + "static/lowerleft_box-d6c406b2309688f676d3ae44a8cedfe7.png";